import { type FC } from "react";
import { PlotCard } from "../../../shared/layout/PlotCard";
import { PlotDesigns } from "../constants";
import { type PlotCardDetaillsInterface } from "../types";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../shared/utils/translationUtils";
import { useNewTrialState } from "../hooks/NewTrialStateProvider";

interface PlotDesignComponentProps {
  trialData?: any;
}

const PlotDesignComponent: FC<PlotDesignComponentProps> = (trialData) => {
  const { t } = useTranslation();
  const PlotCardDetails = PlotDesigns();
  const { trialProtocolData } = useNewTrialState();
  const isStripType = trialProtocolData?.trial_application_method === "strip";

  return (
    <div className="rates-main">
      <div className="rates-header">
        <h3 className="title" data-testid="plot-design-title">
          {isStripType
            ? formatTranslation(t("newTrial.plotDesign.title.strips"))
            : formatTranslation(t("newTrial.plotDesign.title.plots"))}
        </h3>
        <p className="description" data-testid="plot-design-description">
          {formatTranslation(t("newTrial.plotDesign.description"))}
        </p>
      </div>

      <div className="plot-card-container">
        {PlotCardDetails?.map(
          (item: PlotCardDetaillsInterface, key: number) => (
            <PlotCard
              data={item}
              key={`${item.name}-${key}`}
              trialData={trialData}
            />
          )
        )}
      </div>
    </div>
  );
};

export default PlotDesignComponent;
